import { createSlice } from '@reduxjs/toolkit'

import { getDashboardTasks } from '@/store/dashboard-tasks/thunks'
import { TaskWithBeneficiary } from '@/store/dashboard-tasks/types'

interface State {
  tasks: TaskWithBeneficiary[]
}

const initialState: State = {
  tasks: [],
}

const slice = createSlice({
  name: 'dashboardTasks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboardTasks.fulfilled, (state, action) => {
      state.tasks = action.payload
    })
  },
})

// export const {} = slice.actions
export type { State as DashboardTasksState }
export const dashboardTasksInitialState = initialState
export default slice.reducer
